import api from "./api";

const examService = {
  // ── Exams ──────────────────────────────────────────────────────────────────
  getAll: (params) => api.get("/exams", { params }),

  getById: (id) => api.get(`/exams/${id}`),


  create: (data) => api.post("/exams", data),

  update: (id, data) => api.put(`/exams/${id}`, data),

  remove: (id) => api.delete(`/exams/${id}`),

  // ── Results ────────────────────────────────────────────────────────────────
  getResultSheet: (examId) =>
    api.get(`/exams/${examId}/result-sheet`),

  saveResults: (examId, entries) =>
    api.post(`/exams/${examId}/results`, { entries }),

  getResultsByExam: (examId) =>
    api.get(`/exams/${examId}/results`),

  updateStudentApproval: (examId, studentId, approvalStatus) =>
    api.patch(`/exams/${examId}/results/${studentId}/approval`, { approvalStatus }),

  bulkUpdateApproval: (examId, payload) =>
    api.patch(`/exams/${examId}/results/bulk-approval`, payload),

  updatePublishStatus: (examId, status, autoApproveRemaining = false) =>
    api.patch(`/exams/${examId}/publish-status`, { status, autoApproveRemaining }),

  getResultsByStudent: (studentId) =>
    api.get(`/exams/student/${studentId}/results`),
};

export default examService;
